import {
  IonContent,
  IonPage,
  IonRow,
  IonCol,
  IonButtons,
  IonHeader,
  IonTitle,
  IonToolbar,
  IonBackButton,
  isPlatform,
} from "@ionic/react";
import { resetFormProfile } from "../../store/profileForm/profileForm.reducer";

// Actions
// Selectors
import { CreateProfileForm } from "./components/CreateProfileForm";
import { FormLoading } from "./components/FormLoading";
import { useDispatch } from "react-redux";
import { useEffect } from "react";

export const Profile: React.FC = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(resetFormProfile());
  }, [dispatch]);

  return (
    <IonPage>
      <IonHeader class="ion-no-border">
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton
              text={isPlatform("ios") ? "Perfiles" : ""}
              defaultHref="/app/tic/perfiles"
              color="light"
            />
          </IonButtons>
          <IonTitle>Nuevo Perfil</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <FormLoading />

        <IonRow style={{ height: "100%" }}>
          <IonCol size="12" size-sm="5" style={{ padding: 0 }}>
            <CreateProfileForm />
          </IonCol>
        </IonRow>
      </IonContent>
    </IonPage>
  );
};
